<div class="fill-width mb-3">
	<div class="fill-height me-4">
		<div class="fill-width">
			<mat-form-field class="w-100 pe-2 custom-payment-field">
				<mat-label>Wybierz date od (płatność)</mat-label>
				<input
					matInput
					name="parseFilters.payment__gte"
					[ngModel]="parseFilters().payment__gte"
					(ngModelChange)="updateParseFilter('payment__gte', $event)"
					[matDatepicker]="payment__gte"
				/>
				<mat-hint></mat-hint>
				<mat-datepicker-toggle matSuffix [for]="payment__gte"></mat-datepicker-toggle>
				<mat-datepicker #payment__gte> </mat-datepicker>
			</mat-form-field>
			<mat-form-field class="w-100 ps-2 custom-payment-field">
				<mat-label>Wybierz date do (płatność)</mat-label>
				<input
					matInput
					name="parseFilters.payment__lte"
					[ngModel]="parseFilters().payment__lte"
					(ngModelChange)="updateParseFilter('payment__lte', $event)"
					[matDatepicker]="payment__lte"
				/>
				<mat-hint></mat-hint>
				<mat-datepicker-toggle matSuffix [for]="payment__lte"></mat-datepicker-toggle>
				<mat-datepicker #payment__lte> </mat-datepicker>
			</mat-form-field>
		</div>
		<div class="fill-width">
			<mat-form-field class="w-100 pe-2 custom-payment-field">
				<mat-label>Wybierz date od (księgowanie)</mat-label>
				<input
					matInput
					name="parseFilters.posting__gte"
					[ngModel]="parseFilters().posting__gte"
					(ngModelChange)="updateParseFilter('posting__gte', $event)"
					[matDatepicker]="posting__gte"
				/>
				<mat-hint></mat-hint>
				<mat-datepicker-toggle matSuffix [for]="posting__gte"></mat-datepicker-toggle>
				<mat-datepicker #posting__gte> </mat-datepicker>
			</mat-form-field>
			<mat-form-field class="w-100 ps-2 custom-payment-field">
				<mat-label>Wybierz date do (księgowanie)</mat-label>
				<input
					matInput
					name="parseFilters.posting__lte"
					[ngModel]="parseFilters().posting__lte"
					(ngModelChange)="updateParseFilter('posting__lte', $event)"
					[matDatepicker]="posting__lte"
				/>
				<mat-hint></mat-hint>
				<mat-datepicker-toggle matSuffix [for]="posting__lte"></mat-datepicker-toggle>
				<mat-datepicker #posting__lte> </mat-datepicker>
			</mat-form-field>
		</div>
		<ng-select
			class="custom"
			appendTo="body"
			name="filters.status__in"
			[(ngModel)]="filters.status__in"
			[multiple]="true"
			placeholder="Status"
		>
			@for (item of status(); track item.id) {
				<ng-option [value]="item.id">{{ item.description }}</ng-option>
			}
		</ng-select>
		<ng-select
			class="custom"
			appendTo="body"
			name="filters.kind__in"
			[(ngModel)]="filters.kind__in"
			placeholder="Rodzaj"
			[multiple]="true"
		>
			@for (item of paymentKinds(); track item.id) {
				<ng-option [value]="item.id">{{ item.description }}</ng-option>
			}
		</ng-select>
		<ng-select
			class="custom"
			appendTo="body"
			name="parseFilters.reservation_status"
			[ngModel]="parseFilters().reservation_status"
			(ngModelChange)="updateParseFilter('reservation_status', $event)"
			[multiple]="true"
			placeholder="Status rezerwacji"
		>
			@for (item of reservationStatus(); track item.id) {
				<ng-option [value]="item.id">{{ item.name }}</ng-option>
			}
		</ng-select>
	</div>
	<div class="fill-height me-4">
		<div class="fill-width">
			<mat-form-field class="w-100 pe-2 custom-payment-field">
				<mat-label>Kwota</mat-label>
				<input
					type="number"
					id="parseFilters.amount__gte"
					name="parseFilters.amount__gte"
					[ngModel]="parseFilters().amount__gte"
					(ngModelChange)="updateParseFilter('amount__gte', $event)"
					matTooltip="(większa lub równa)"
					matInput
				/>
			</mat-form-field>
			<mat-form-field class="w-100 ps-2 custom-payment-field">
				<mat-label>Kwota</mat-label>
				<input
					type="number"
					id="parseFilters.amount__lt"
					name="parseFilters.amount__lt"
					[ngModel]="parseFilters().amount__lt"
					(ngModelChange)="updateParseFilter('amount__lt', $event)"
					matInput
					matTooltip="(mniejsza)"
				/>
			</mat-form-field>
		</div>
		<ng-select
			class="custom"
			appendTo="body"
			name="filters.currency__in"
			[(ngModel)]="filters.currency__in"
			[multiple]="true"
			placeholder="Waluta"
		>
			@for (item of currency(); track item.id) {
				<ng-option [value]="item.id">{{ item.name }}</ng-option>
			}
		</ng-select>
		@for (resetKey of [autocompleteResetKey()]; track resetKey) {
			<app-generic-mat-autocomplete
				[apiUrl]="organizationApiUrl"
				[apiSearchParam]="organizationApiSearchParam"
				[placeholder]="'Organizatorzy (min. 3 znaki)'"
				[idKey]="'id'"
				[displayKeys]="['shortName']"
				(selected)="onOrganizationSelected($event)"
			></app-generic-mat-autocomplete>
			<app-generic-mat-autocomplete
				[apiUrl]="organizationApiUrl"
				[apiSearchParam]="agencyApiSearchParam"
				[placeholder]="'Agent (min. 3 znaki)'"
				[idKey]="'id'"
				[displayKeys]="['shortName']"
				[multiple]="true"
				(selectedMultiple)="onAgenciesSelected($event)"
			></app-generic-mat-autocomplete>
		}
	</div>
	<div class="fill-height me-4">
		<ng-select
			class="custom"
			appendTo="body"
			name="filters.bank_account_posting__in"
			[(ngModel)]="filters.bank_account_posting__in"
			[multiple]="true"
			placeholder="Konto wpłaty"
		>
			@for (item of bankAccounts(); track item.id) {
				<ng-option [value]="item.id">{{ item.number }}</ng-option>
			}
		</ng-select>
		<mat-form-field class="w-100 custom-payment-field">
			<mat-label>Konto płatnika</mat-label>
			<input
				type="text"
				id="filters.bank_account_incoming__icontains"
				name="filters.bank_account_incoming__icontains"
				[(ngModel)]="filters.bank_account_incoming__icontains"
				matInput
			/>
		</mat-form-field>
	</div>
	<div class="fill-height me-4">
		<mat-form-field class="w-100 custom-payment-field">
			<mat-label>Faktura</mat-label>
			<input
				type="text"
				id="filters.invoice_number__icontains"
				name="filters.invoice_number__icontains"
				[(ngModel)]="filters.invoice_number__icontains"
				matInput
				placeholder="Faktura"
			/>
		</mat-form-field>
		<mat-form-field class="w-100 custom-payment-field">
			<mat-label>Numer rezerwacji</mat-label>
			<input
				type="text"
				id="filters.table_id__in"
				name="filters.table_id__in"
				[(ngModel)]="filters.table_id__in"
				matInput
				placeholder="Numer rezerwacji"
			/>
		</mat-form-field>
	</div>
</div>

<div class="text-end">
	<div class="col align-self-end">
		<button class="me-2 mat-custom-button mat-primary-button" mat-raised-button (click)="filtersSave()">
			Pokaż
		</button>
		<button class="mat-custom-button" mat-raised-button (click)="filtersClear()">Wyczyść</button>
	</div>
</div>
